import React from 'react';
import styled from 'styled-components';
import { TextField } from '../../fields/TextField';
import { SmartformElementData } from '../../types';
import MultiColumns from '../../forms/layouts/MultiColumns';
import { getElementFields } from '../../forms/utils/getElementFields';
import { filterNotEmpty } from '../../forms/utils/listHelpers';

export const PreferredName: React.FC<SmartformElementData> = (props) => {
  const {
    required: [preferredFirst, preferredLast],
    optional: { middleName, secondaryLastName }
  } = getElementFields<4>(props);

  return (
    <div>
      <StyledNameField>
        <TextField
          name={preferredFirst.name}
          helperText={preferredFirst.helpText}
          placeholder={preferredFirst.hint}
          label={preferredFirst.label}
          required={preferredFirst.validation.required}
        />
      </StyledNameField>
      {middleName && (
        <StyledNameField>
          <TextField
            name={middleName.name}
            helperText={middleName.helpText}
            placeholder={middleName.hint}
            label={middleName.label}
            required={middleName.validation.required}
          />
        </StyledNameField>
      )}
      <MultiColumns
        xs={[12, 12]}
        elements={filterNotEmpty([
          <TextField
            name={preferredLast.name}
            key={preferredLast.name}
            helperText={preferredLast.helpText}
            placeholder={preferredLast.hint}
            label={preferredLast.label}
            required={preferredLast.validation.required}
          />,
          secondaryLastName && (
            <TextField
              name={secondaryLastName.name}
              key={secondaryLastName.name}
              helperText={secondaryLastName.helpText}
              placeholder={secondaryLastName.hint}
              label={secondaryLastName.label}
              required={secondaryLastName.validation.required}
            />
          )
        ])}
      />
    </div>
  );
};

const StyledNameField = styled.div`
  margin: 0 0 8px 0;
`;
